import { render } from "./PaymentFailed.vue?vue&type=template&id=49dcb7ca&ts=true"
import script from "./PaymentFailed.vue?vue&type=script&lang=ts"
export * from "./PaymentFailed.vue?vue&type=script&lang=ts"

import "./PaymentFailed.vue?vue&type=style&index=0&id=49dcb7ca&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__